(function () {
  'use strict';

  // A third-party script injected via content_for_header (confirmed live to be unrelated
  // to this theme's own code) attaches a 'submit' listener to the cart form that blocks
  // the native checkout navigation. Intercepting in the capture phase and stopping
  // propagation lets the browser's default submit action proceed while preventing that
  // listener from running.
  //
  // NOTE: if `cart_terms_page` is ever configured (currently blank), this will also
  // suppress cart-terms.js's own submit validation on the same form, since that's
  // registered on the same element. Revisit this interaction before enabling that setting.
  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (form instanceof HTMLFormElement && form.matches('[action$="/cart"]')) {
      event.stopImmediatePropagation();
    }
  }, true);
})();
